export default {
  dataKeys: {
    description: "description",
    settledDate: "settledDate",
    totalCharge: "totalAmount",
    transactionDate: "billDate",
    transactionType: "transactionType"
  },
  headers: {
    description: "Description",
    settledDate: "Settled Date",
    totalCharge: "Total",
    transactionDate: "Bill Date",
    transactionType: "Transaction Type"
  },
  philter: "billing-history-transactions",
  rowKey: "billId",
  tableKey: "billing_history_table"
};
